import { render, staticRenderFns } from "./LatestReportsListItem.vue?vue&type=template&id=0bf32aaa&scoped=true&"
import script from "./LatestReportsListItem.vue?vue&type=script&lang=js&"
export * from "./LatestReportsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LatestReportsListItem.vue?vue&type=style&index=0&id=0bf32aaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf32aaa",
  null
  
)

export default component.exports